import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { NoDataIcon } from 'src/components/BeaconV2Components/common/NoDataPlaceHolder/NoDataPlaceHolder';
import { NoneFoundIcon } from 'src/components/SvgIcons';
import { Typography } from '@mui/material';
import { useStacklineTheme } from '@stackline/ui';
import colors from 'src/utils/colors';

interface NoDataPlaceholderWithChildrenProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

export const NoDataPlaceholderWithChildren = ({ title, subtitle, children }: NoDataPlaceholderWithChildrenProps) => {
  const theme = useStacklineTheme();

  return (
    <Flex gap={20} flexDirection="column" alignItems="start">
      <NoDataIcon
        icon={<NoneFoundIcon />}
        iconBackgroundStyle={{
          backgroundColor: theme.colors.secondaryGhost,
          opacity: 1
        }}
      />
      <Flex flexDirection="column" gap="sm" alignItems="start">
        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            letterSpacing: 'normal',
            textAlign: 'left',
            color: colors.darkBlue
          }}
          variant="subtitle1"
        >
          {title}
        </Typography>
        {subtitle && <Text sx={{ maxWidth: '264px', lineHeight: '24px' }}>{subtitle}</Text>}
        {children}
      </Flex>
    </Flex>
  );
};

export const NoDataPlaceholderWithChildrenSmall = ({
  title,
  subtitle,
  children
}: NoDataPlaceholderWithChildrenProps) => {
  const theme = useStacklineTheme();

  return (
    <Flex gap={16} flexDirection="column" alignItems="start">
      <NoDataIcon
        icon={<NoneFoundIcon />}
        iconBackgroundStyle={{
          backgroundColor: theme.colors.secondaryGhost,
          opacity: 1
        }}
      />
      <Flex flexDirection="column" gap="xs" alignItems="start">
        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            letterSpacing: 'normal',
            textAlign: 'left',
            color: colors.darkBlue
          }}
          variant="subtitle1"
        >
          {title}
        </Typography>
        {subtitle && <Text sx={{ fontSize: '14px', lineHeight: '24px' }}>{subtitle}</Text>}
        {children}
      </Flex>
    </Flex>
  );
};
